import Post, {IPost} from '@/models/Post'

export interface INewJob extends IPost {
}

export default class NewJob extends Post {
  constructor(defaults?: INewJob) {
    super(defaults)
    if (defaults) {
    }
  }

  get className(): string {
    return NewJob.name
  }
}
